import React, { useState, useRef, useEffect, useCallback } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Canvas, { CANVAS_ID } from "../../components/canvas/Canvas/Canvas";
import "./home.style.scss";
import {
  getUser,
  setTimer,
  setImageProcessing,
  invokeScore,
  setActiveModel,
  setDrawingEvaluationError,
} from "../../state/actions";
// import Timer from "../../child/timer/Timer";
import { ActiveModel } from "../../types/model";
import { DRAWING_EVALUATION_ERROR } from "../../constants/site-content";
import InteractiveDrawingModel, {
  InteractiveModelProperties,
} from "../../components/model/InteractiveDrawingModel/InteractiveDrawingModel";
import Timer from "../../components/timer/Timer";
import { DrawingEnvironment } from "../../components/drawingenvironment/DrawingEnvironment";
import { COMPETES_URL } from "../../components/navbar/Navbar";
import { useNavigate } from "react-router";
import Layout from "../../components/layout/Layout";
import TutorialModal from "../../components/tutorialmodal/TutorialModal";
import useCroqeeTutorial from "../../hooks/useCroqeeTutorial";
import { UNLIMITED_TIMER_MAX } from "../../components/timeroptions/TimerOptions";
//import { isNativeApp } from "../../utils/platform";
import appConfig from "../../config/app-config.json";
import config from "../../modules/config";
import VerticalResizer from "../../components/splitter/VerticalResizer";
export const HOME_DRAWING_GIVEN_TIME = UNLIMITED_TIMER_MAX;

const FALLBACK_DEFAULT_MODEL_NAME = appConfig.fallBackDefaultModel.name;

type ITimer = {
  showTimer: boolean;
  timer: number;
};

export interface HomePageProps extends React.Component<any> {
  getUser?: () => void;
  setImageProcessing?: (bool: boolean) => void;
  setTimer?: (timer: ITimer) => void;
  setTimerDone?: (bool: boolean) => void;
  activeModel?: ActiveModel;
  canvasWidth?: number;
  canvasHeight?: number;
  invokeScore?: (score: number) => void;
  startImageProcessing?: boolean;
  leftHand?: boolean;
  showTimer?: boolean;
  setActiveModel?: (activeModel: ActiveModel) => void;
  path?: any;
}
export interface MappedProps {
  setDrawingEvaluationError?: (error: string) => void;
}

const Home = (props: (HomePageProps & MappedProps) | any): JSX.Element => {
  const [baseURL, setBaseURL] = useState("");
  const [shouldResetCanvas, setShouldResetCanvas] = useState(false);
  const initialRef: any = null;
  const interactiveModel = useRef(initialRef);
  const navigate = useNavigate();
  const [defaultModel, setDefaultModel] =
    useState<InteractiveModelProperties>(null);
  const [tutorialModalOpen, setTutorialModalOpen] = useState(false);
  const { isCroqeeTutorialDone, setIsCroqeeTutorialDone } = useCroqeeTutorial();

  useEffect(() => {
    if (!isCroqeeTutorialDone) {
      setTutorialModalOpen(true);
    }
  }, [isCroqeeTutorialDone, setIsCroqeeTutorialDone]);
  const handleCloseTutorial = useCallback(() => {
    setTutorialModalOpen(false);
    setIsCroqeeTutorialDone(true);
  }, [setIsCroqeeTutorialDone]);
  useEffect(() => {
    props.getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    // Load all models and pick the one marked as defaultModel === true.
    const authorizedHeader = config?.AuthorizationHeader
      ? config.AuthorizationHeader()
      : {};
    axios
      .get(
        `${process.env.REACT_APP_CROQEE_SERVER_URL}/models/getAllThreeDModels`,
        authorizedHeader
      )
      .then((res: any) => {
        const list = res?.data?.threeDModels?.data || [];
        const def =
          (list.find((m: any) => m && m.defaultModel === true) as any) ||
          (list.find(
            (m: any) => m && m.model === FALLBACK_DEFAULT_MODEL_NAME
          ) as any) ||
          (list.length > 0 ? list[0] : null);
        if (def) {
          setDefaultModel({
            modelName: def.model,
            modelUrl: def.threeDModelUrl,
            overLineColor: def.overLineColor,
            cameraPosition: def.cameraPosition,
            controlTarget: def.controlTarget,
            outLineSpec: def.outLineSpec,
            modelScale: def.modelScale,
            hasTexture: !!def.hasTexture,
          });
        } else {
          axios
            .get(
              `${process.env.REACT_APP_CROQEE_SERVER_URL}/public-model/getPublicModelByName`,
              { params: { modelName: FALLBACK_DEFAULT_MODEL_NAME } }
            )
            .then((r: any) => {
              const model = r?.data?.model;
              if (model) {
                setDefaultModel({
                  modelName: model.model,
                  modelUrl: model.threeDModelUrl,
                  overLineColor: model.overLineColor,
                  cameraPosition: model.cameraPosition,
                  controlTarget: model.controlTarget,
                  outLineSpec: model.outLineSpec,
                  modelScale: model.modelScale,
                  hasTexture: !!model.hasTexture,
                });
              }
            })
            .catch(() => {});
        }
      })
      .catch(() => {
        axios
          .get(
            `${process.env.REACT_APP_CROQEE_SERVER_URL}/public-model/getPublicModelByName`,
            { params: { modelName: FALLBACK_DEFAULT_MODEL_NAME } }
          )
          .then((r: any) => {
            const model = r?.data?.model;
            if (model) {
              setDefaultModel({
                modelName: model.model,
                modelUrl: model.threeDModelUrl,
                overLineColor: model.overLineColor,
                cameraPosition: model.cameraPosition,
                controlTarget: model.controlTarget,
                outLineSpec: model.outLineSpec,
                modelScale: model.modelScale,
                hasTexture: !!model.hasTexture,
              });
            }
          })
          .catch(() => {});
      });
  }, []);

  useEffect(() => {
    if (props.startImageProcessing) {
      if (props.startImageProcessing) {
        sendDrawing();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.startImageProcessing]);

  const getOutlineScreenShot = () => {
    const outlineBase64 = interactiveModel?.current?.getOutlineScreenShot();
    return outlineBase64;
  };
  const getModelScreenShot = () => {
    const outlineBase64 = interactiveModel?.current?.getModelScreenShot();
    return outlineBase64;
  };
  const navigateToClubPage = () => {
    navigate(COMPETES_URL);
  };
  const sendDrawing = () => {
    const canvas = document.getElementById(CANVAS_ID) as HTMLCanvasElement;
    if (canvas) {
      props.setImageProcessing(true);
      const dataURL = canvas
        .toDataURL("image/jpeg", 0.8)
        .replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
      let modelOutlineDataURL = getOutlineScreenShot();
      let modelDataURL = getModelScreenShot();
      props.setActiveModel({
        modelDataURL: modelDataURL,
      });
      modelOutlineDataURL = modelOutlineDataURL.replace(
        /^data:image\/(png|jpg|jpeg);base64,/,
        ""
      );
      props.setTimer({ showTimer: false, timer: 30 });
      const model = "";

      axios
        .post(`${process.env.REACT_APP_CROQEE_SERVER_URL}/send_drawing`, {
          user: props.user,
          dataURL: dataURL,
          modelOutlineDataURL: modelOutlineDataURL,
          model: model,
          canvasWidth: props.canvasWidth,
          canvasHeight: props.canvasHeight,
          modelName: props.activeModelPropertiesAndIdentity,
          drawingTime: props.homeDrawingGivenTime,
        })
        .then((response) => {
          if (response.data.img) {
            const score = response.data.score || 0;
            setBaseURL("data:image/png;base64, " + response.data.img);
            props.setImageProcessing(false);
            props.invokeScore({
              score,
              extraFraction: response.data.extraFraction,
              missingFraction: response.data.missingFraction,
              lineBalance: response.data.lineBalance,
            });
            setShouldResetCanvas(true);
          } else {
            const score = 0;
            props.setDrawingEvaluationError(
              DRAWING_EVALUATION_ERROR.processingError
            );
            props.setImageProcessing(false);
            props.invokeScore(score);
            setShouldResetCanvas(true);
          }
        })
        .catch((_e) => {
          console.error(_e);
          const score = 0;
          props.setDrawingEvaluationError(
            DRAWING_EVALUATION_ERROR.serverConnectionError
          );
          props.setImageProcessing(false);
          props.invokeScore(score);
          setShouldResetCanvas(true);
        });
    }
  };

  const side = props.leftHand ? "model_left_hand" : "";

  return (
    <Layout>
      <TutorialModal
        images={[
          {
            url: "/images/tips/part-1.png",
            text: "Swicthing on this button will only show the outline of the model.",
          },
          {
            url: "/images/tips/part-2.png",
            text: "With this button you can select between other models to draw.",
          },
          {
            url: "/images/tips/part-3.png",
            text: "This option will allow you to adjust the time given to draw the model.",
          },
          {
            url: "/images/tips/part-4.png",
            text: "At the top of the screen using this option you can swap the canvas and model positions.",
          },
          {
            url: "/images/tips/part-5.png",
            text: "At the side of the canvas you can adjust the brush size or switch between the eraser and the brush.",
          },
          {
            url: "/images/tips/part-6.png",
            text: "As soon as you start drawing the timer will start counting down from the given time. When the time is done the drawing will be evaluated and you will be given a score.",
          },
          {
            url: "/images/tips/part-7.png",
            text: "Using the menu button at the top right corner you can navigate to the live drawing, leaderboard, profile page and more.",
          },
        ]}
        open={tutorialModalOpen}
        onClose={handleCloseTutorial}
      />
      <DrawingEnvironment side={side}>
        {props.showTimer && <Timer />}
        {props.canvasWidth && props.canvasHeight && (
          <InteractiveDrawingModel
            modelName={defaultModel?.modelName || ""}
            componentRef={interactiveModel}
            modelUrl={defaultModel?.modelUrl || ""}
            allowUserCameraControl={true}
            hasTexture={!!defaultModel?.hasTexture}
            cameraPosition={defaultModel?.cameraPosition}
            modelScale={defaultModel?.modelScale}
            controlTarget={defaultModel?.controlTarget}
            outLineSpec={{
              normalMultiplier: defaultModel?.outLineSpec?.normalMultiplier,
              normalBias: defaultModel?.outLineSpec?.normalBias,
              overLineNormalMultiplier:
                defaultModel?.outLineSpec?.overLineNormalMultiplier,
              overLineNormalBias: defaultModel?.outLineSpec?.overLineNormalBias,
            }}
            setShouldResetCanvas={setShouldResetCanvas}
          />
        )}
        <VerticalResizer />
        <Canvas
          isInHomePage={true}
          setBaseUrl={setBaseURL}
          shouldResetCanvas={shouldResetCanvas}
          setShouldResetCanvas={setShouldResetCanvas}
          canStartDrawing={true}
          baseURL={baseURL}
          navigateToClubPage={navigateToClubPage}
          model={{
            model: "",
            url: "",
            givenTime: 0,
            isDrawn: false,
            modelDataURL: "",
            threeDModelUrl: "",
            cameraPosition: {
              x: 0,
              y: 0,
              z: 0,
            },
            modelScale: 0,
            controlTarget: {
              x: 0,
              y: 0,
              z: 0,
            },
            normalMultiplier: 0,
            outLineSpec: {
              normalMultiplier: 0,
              outlineSharpness: 0,
              normalBias: 0,
              depthMultiplier: 0,
            },
          }}
          setHasUserDrawnOnCanvas={function (bool: boolean): void {
            throw new Error("Function not implemented.");
          }}
          isCompeting={false}
          canJoinClub={false}
          imgPath={""}
        />
      </DrawingEnvironment>
    </Layout>
  );
};

const mapStateToProps = (state: any) => {
  const {
    events,
    user,
    showTimer,
    scoreClass,
    currentScore,
    leftHand,
    timerDone,
    startImageProcessing,
    activeModel,
    canvasWidth,
    canvasHeight,
    activeModelPropertiesAndIdentity,
    homeDrawingGivenTime,
  } = state;
  return {
    events,
    user,
    showTimer,
    scoreClass,
    currentScore,
    leftHand,
    timerDone,
    startImageProcessing,
    activeModel,
    canvasWidth,
    canvasHeight,
    activeModelPropertiesAndIdentity,
    homeDrawingGivenTime,
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    getUser: () => dispatch(getUser()),
    setTimer: (payload: any) => dispatch(setTimer(payload)),
    setImageProcessing: (payload: any) => dispatch(setImageProcessing(payload)),
    invokeScore: (payload: any) => dispatch(invokeScore(payload)),
    setActiveModel: (payload: any) => dispatch(setActiveModel(payload)),
    setDrawingEvaluationError: (payload: any) =>
      dispatch(setDrawingEvaluationError(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
